/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description navbar constants
 */

export const SET_MOBILE_VIEW_TYPE = '@@nzr/navbar/SET_MOBILE_VIEW_TYPE'
export const SET_NAVBAR_STICKY = '@@nzr/navbar/SET_NAVBAR_STICKY'
